/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type MoveBookingByClientPayload = {
    start: DateTime;
    ruleId: number;
    selectedLocation: MoveBookingByClientPayload.selectedLocation;
    message?: string;
};
export namespace MoveBookingByClientPayload {
    export enum selectedLocation {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

